import { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { InfoIcon } from 'src/components/Icons/Info';
import { UiInnerNotSPALink } from 'src/components/UI/InnerNotSPALink';
import { UiModal } from 'src/components/UI/modal/UiModal';
import {
  deCommonCurrentPartnerSelector,
  showPersonalOrBusinessForBusinessModalSelector,
} from 'src/store/commonPart/selector';
import { commonSlice } from 'src/store/commonPart/slice';
import styles from 'src/styles/common/_personalOrBusinessForBusinessModal.module.scss';
import { useNsTHelper } from 'src/utils/i18n';

const Modal: FC = () => {
  const { t } = useTranslation();
  const ns = 'modals.personalOrBusinessForBusiness';
  const tHelper = useNsTHelper(ns);

  const { ContactEmail, Name } = useSelector(deCommonCurrentPartnerSelector);

  const dispatch = useDispatch();

  const handleClose = () => dispatch(commonSlice.actions.hidePersonalOrBusinessForBusinessModal());

  return (
    <UiModal
      onlySuccessBtn
      onHide={handleClose}
      modalClassName={styles.modal}
      successBtnText={t('common.close')}
      header={
        <div className={styles.header}>
          <InfoIcon className={styles.icon} />
          {tHelper('header')}
        </div>
      }
    >
      <div>{tHelper('description', { partnerName: Name })}</div>
      <div>{tHelper('info')}</div>
      <div className={styles.feedback}>
        <Trans i18nKey="feedback" ns={ns} values={{ email: ContactEmail }}>
          <UiInnerNotSPALink href={`mailto:${ContactEmail}`} className={styles.link}>
            1
          </UiInnerNotSPALink>
        </Trans>
      </div>
    </UiModal>
  );
};

export const PersonalOrBusinessForBusinessModal: FC = () => {
  const showModal = useSelector(showPersonalOrBusinessForBusinessModalSelector);

  return showModal ? <Modal /> : null;
};
